import { getBroadcastRouteMatch } from 'actions/utils';
import { isEqual, debounce } from 'underscore';
import emitSocketEvent from '@shoflo/studio-redux/utils/emitSocketEvent';
import { DEBOUNCE_PROGRAM_UPDATES } from '@studio/constants/SocketEvents';

export default async function attendeeCameraStatusEmitter() {
  // Emit anytime attendeeCameraStatus Changes
  const { attendeeCameraStatus } = this.store.getState();
  if (isEqual(attendeeCameraStatus, this._camerastatus)) return;
  this._camerastatus = attendeeCameraStatus;
  const routeMatch = getBroadcastRouteMatch(this.store.getState);
  if (!routeMatch) return;
  const {
    params: { broadcastId }
  } = routeMatch;

  debounceCameraStatusChange(this.socket, 'attendeesCameraStatusChange', {
    attendeeCameraStatus,
    broadcastId
  });
}

const debounceCameraStatusChange = debounce(
  emitSocketEvent,
  DEBOUNCE_PROGRAM_UPDATES
);
